import React from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AppLayout from "layouts/app-layout";
import AuthLayout from 'layouts/auth-layout';
import AppLocale from "lang";
import { IntlProvider } from "react-intl";
import { ConfigProvider } from 'antd';
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH, NOT_FOUND_PATH } from 'configs/AppConfig'
import useBodyClass from 'hooks/useBodyClass';
import RoleBasedRouting from "auth/gard/RoleBasedRouting";
import PublicRoute from "auth/gard/PublicRoute";
import { ROLES } from "constants/Permissions";
import ErrorOne from "./errors/error-page-1";
import JwtAuthService from "services/JwtAuthService";
import { useQuery } from "@tanstack/react-query";

export const Views = (props) => {
  const { locale, location, direction } = props;
  const currentAppLocale = AppLocale[locale] || AppLocale.en;
  useBodyClass(`dir-${direction}`);
  useQuery(
    {
      queryKey: ['refresh_token'],
      queryFn: () => JwtAuthService.refreshToken().then(() => null),
      // SessionGate already refreshed on startup, so don't refresh again on mount.
      initialData: null,
      staleTime: 2700000,
      retry: false,
      refetchInterval: 2700000,
      refetchIntervalInBackground: true,
      refetchOnWindowFocus: false,
      throwOnError: false,
      notifyOnChangeProps: [],
      enabled: location.pathname.startsWith(APP_PREFIX_PATH),
    }
  );
  return (
    <IntlProvider
      locale={currentAppLocale.locale}
      messages={currentAppLocale.messages}>
      <ConfigProvider locale={currentAppLocale.antd} direction={direction}>
        <Switch>
          <Route exact path="/">
            <Redirect to={AUTH_PREFIX_PATH} />
          </Route>
          <PublicRoute path={AUTH_PREFIX_PATH}>
            <AuthLayout direction={direction} />
          </PublicRoute>
          {/* Main app route - requires any admin permission (ROLE_MASTER or any other admin role) */}
          <RoleBasedRouting path={APP_PREFIX_PATH} AuthNeeded={[ROLES.USER]}>
            <AppLayout direction={direction} location={location} />
          </RoleBasedRouting>
          <Route path={NOT_FOUND_PATH}>
            <ErrorOne />
          </Route>
          <Redirect to={APP_PREFIX_PATH} />
        </Switch>
      </ConfigProvider>
    </IntlProvider>
  )
}

const mapStateToProps = ({ theme, auth }) => {
  const { locale, direction } = theme;
  const { token } = auth;
  return { locale, token, direction }
};

export default withRouter(connect(mapStateToProps)(Views));
